import { render, staticRenderFns } from "./PreferencesAdmin.vue?vue&type=template&id=702be50d"
import script from "./PreferencesAdmin.vue?vue&type=script&lang=js"
export * from "./PreferencesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports